import { Checkbox, Col, Dropdown, Menu, Radio, RadioChangeEvent, notification } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { PureComponent, ReactNode } from 'react';
import setHXNGConsent from '../../../../api/setHXNGConsent';
import { captureError } from '../../../../pages/captureError';
import { track } from '../../../../tracking';

type Props = {
    isConciergeChecked?: boolean;
    conciergeDiscount?: string;
    conciergeCheckboxToggler: (e: CheckboxChangeEvent) => void;
    conciergeDiscountToggler: (e: RadioChangeEvent) => void;
};

const ID = 'concierge-button';

export class ConciergeButton extends PureComponent<Props> {
    render(): ReactNode {
        const {
            isConciergeChecked,
            conciergeDiscount,
            conciergeCheckboxToggler,
            conciergeDiscountToggler,
        } = this.props;

        return (
            <Dropdown
                overlay={
                    <Menu className="flex flex-col text-neutral-2 font-600">
                        <Radio.Group value={conciergeDiscount} onChange={conciergeDiscountToggler}>
                            <Col>
                                <Radio value={'discount'} className="text-13 mx-8 my-4">
                                    Discount
                                </Radio>
                            </Col>
                            <Col>
                                <Radio value={'no-discount'} className="text-13 mx-8 my-4">
                                    No Discount
                                </Radio>
                            </Col>
                        </Radio.Group>
                    </Menu>
                }
                placement="topCenter"
                arrow={undefined}
                trigger={['hover']}
                getPopupContainer={() => document.getElementById(ID) || document.body}
            >
                <div id={ID}>
                    <Checkbox
                        checked={isConciergeChecked}
                        className={`select-none border border-darwin-accent-bright-blue-800 pl-16 pr-8 py-8 text-darwin-accent-bright-blue-800 font-700 rounded-4`}
                        onChange={conciergeCheckboxToggler}
                    >
                        Concierge
                    </Checkbox>
                </div>
            </Dropdown>
        );
    }
}

export function saveConcierge(
    pxId: string,
    patientId: string,
    conciergeDiscount?: string,
    totalLabTests?: number,
) {
    setHXNGConsent({
        pxid: pxId,
        patientid: patientId,
        concierge: true,
        concierge_discount: conciergeDiscount === 'discount' ? true : false,
        sell: 'lab',
        total_lab_tests: totalLabTests,
    })
        .then((i) => {
            if (i.success) {
                notification.success({
                    message: `Rx Concierge Initiated!`,
                    duration: 5,
                    placement: 'topRight',
                });
                track('SAVE_CONCIERGE', {
                    pxid: pxId,
                    patientid: patientId,
                    concierge_discount: conciergeDiscount === 'discount' ? 'true' : 'false',
                    total_lab_tests: String(totalLabTests),
                });
            } else {
                notification.error({
                    message: 'Error in Initiating Rx Concierge!',
                    duration: 5,
                    placement: 'topRight',
                });
                track('ERROR', {
                    on: 'setHXNGConsent [saveConcierge]',
                    error: 'Error in Initiating Rx Concierge!',
                });
            }
        })
        .catch((err) => {
            captureError(err as Error);
            track('ERROR', {
                on: 'setHXNGConsent [saveConcierge]',
                error: (err as Error).message,
            });
            notification.error({
                message: 'Error in Initiating Rx Concierge!',
                duration: 5,
            });
        });
}
